// JavaScript Document
//================================
//  animation
//================================
jQuery(function($){

	//-----------------------------
	//animate
	//-----------------------------
	var scroll = 0;
	window.addEventListener('load', function(){
		$(".anime").each(function(){
			var anime_pos = $(this).offset().top;    
			var windowHeight = $(window).height();
//console.log(anime_pos)
			scroll = $(window).scrollTop();

			if (scroll > anime_pos - windowHeight + windowHeight / 10){				
				$(this).addClass('animated');
			}
		});
	});

	$(window).on('scroll', function(){
		$(".anime").each(function(){
			var anime_pos2 = $(this).offset().top;    
			var windowHeight2 = $(window).height();

			scroll = $(window).scrollTop();

			if (scroll > anime_pos2 - windowHeight2 + windowHeight2 / 10){				
				$(this).addClass('animated');
			}
		});
	});

});